import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { EventosGenericosComponent } from './eventos-genericos/eventos-genericos.component';
// Sirena specific listing removed — keep generic 'Vivos' only
import { EventosGenericosVivosComponent } from './listado-eventos-genericos-vivo/eventos-genericos-vivos.component';
import { EventosGenericosEsperaComponent } from './listado-eventos-genericos-espera/eventos-genericos-espera.component';
import { EventosGenericosHistoricoComponent } from './listado-eventos-genericos-historico/eventos-genericos-historico.component';
import { EventosGenericosRoutingModule } from './routing';
// Tratamiento de eventos genéricos
import { TratamientoGenericoComponent } from './tratar-evento-generico/tratamiento-generico/tratamiento-generico.component';
import { AgregarNotaGenericoComponent } from './tratar-evento-generico/agregar-nota-generico/agregar-nota-generico.component';
import { PonerEnEsperaGenericoComponent } from './tratar-evento-generico/poner-en-espera-generico/poner-en-espera-generico.component';
import { HistoricoEventoGenericoDialogComponent } from './tratar-evento-generico/historico-evento-generico-dialog/historico-evento-generico-dialog.component';
// Eventos técnicos genéricos
import { CrearEditarEventoTecnicoGenericoComponent } from './eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosTecnicosGenericoDispositivoComponent } from './eventos-tecnicos-genericos/eventos-tecnicos-dispositivo/eventos-tecnicos-generico-dispositivo.component';
import { RangosHorariosComponent } from '../../standalone/rangos-horarios/rangos-horarios.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CopyClipboardDirective } from '../../../auxiliares/directives/copy-clipboard.directive';
import { FilasProgresivasDirective } from '../../../auxiliares/directives/filas-progresivas.directive';
import { EnviarMovilComponent } from './tratar-evento-generico/enviar-movil/enviar-movil.component';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { DetallesEventoGenericoComponent } from './detalles-evento-generico/detalles-evento-generico.component';
import { ListadoCategoriasSelectorComponent } from '../../../componentes/selectores/listado-categoria-selector/listado-categoria-selector.component';
import { CarruselComponent } from '../../../auxiliares/carrusel/carrusel.component';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';

@NgModule({
  declarations: [
    EventosGenericosComponent,
    EventosGenericosVivosComponent,
    EventosGenericosEsperaComponent,
    EventosGenericosHistoricoComponent,
    TratamientoGenericoComponent,
    AgregarNotaGenericoComponent,
    PonerEnEsperaGenericoComponent,
    HistoricoEventoGenericoDialogComponent,
    // Eventos técnicos genéricos
    CrearEditarEventoTecnicoGenericoComponent,
    EventosTecnicosGenericoDispositivoComponent,
    //
    EnviarMovilComponent,
    DetallesEventoGenericoComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    EventosGenericosRoutingModule,
    RangosHorariosComponent,
    CopyClipboardDirective,
    FilasProgresivasDirective,
    MapCardComponent,
    DragDropModule,
    ListadoCategoriasSelectorComponent,
    CarruselComponent,
    PasosNavComponent,
  ],
  exports: [EventosGenericosHistoricoComponent],
})
export class EventosGenericosModule {}
